import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { passingsToExport, showCheckboxColumn } from 'api/passings/getFilteredPassings';
import { DownloadButton } from 'components/Button';
import { PASSINGS_BY_TRANSACTION_DOWNLOAD_URL, PASSINGS_DOWNLOAD_URL } from 'constants/urls';
import dateTimeFormatter from 'utils/date/dateTimeFormatter';
import downloadBlob from 'utils/download/downloadBlob';
import isNorwegian from 'utils/language/isNorwegian';
import useStyles from './TagPassingStyles';
export default function TagPassingsDownload({
  dates,
  disabled,
  obeNumber,
  max,
  accountId
}) {
  const {
    t,
    i18n
  } = useTranslation();
  const [isDownloadingCsv, setIsDownloadingCsv] = useState(false);
  const [isDownloadingPdf, setIsDownloadingPdf] = useState(false);
  const {
    downloadButtons,
    column
  } = useStyles();
  const passingsToExportLst = useRecoilValue(passingsToExport);
  const showCheckbox = useRecoilValue(showCheckboxColumn);
  const disableButtons = disabled || isDownloadingCsv || isDownloadingPdf || showCheckbox && passingsToExportLst.length === 0 || !max;
  const handleDownloadClick = async format => {
    const url = PASSINGS_DOWNLOAD_URL;
    const filename = `${t('tag.tag')}_${obeNumber}${dates?.dateFrom ? `_${dateTimeFormatter(dates.dateFrom)}` : ''}${dates?.dateFrom && dates?.dateTo ? '-' : ''}${dates?.dateTo ? `_${dateTimeFormatter(dates?.dateTo)}` : ''}.${format}`;
    const data = {
      ...dates,
      offset: 0,
      max,
      obeNumbers: [obeNumber],
      language: isNorwegian(i18n) ? 'No' : 'Eng',
      format
    };
    await downloadBlob(url, filename, 'POST', data);
  };
  const handleDownloadByTransactionClick = async format => {
    const url = PASSINGS_BY_TRANSACTION_DOWNLOAD_URL;
    const filename = `${t('passings.passings')}.${format}`;
    const data = {
      offset: 0,
      language: isNorwegian(i18n) ? 'No' : 'Eng',
      format,
      transactionIds: passingsToExportLst,
      max: 10,
      accountId
    };
    await downloadBlob(url, filename, 'POST', data);
  };
  const handleDownloadPdfClick = async () => {
    setIsDownloadingPdf(true);
    try {
      if (passingsToExportLst.length > 0) {
        handleDownloadByTransactionClick('pdf');
      } else {
        await handleDownloadClick('pdf');
      }
    } finally {
      setIsDownloadingPdf(false);
    }
  };
  const handleDownloadCsvClick = async () => {
    setIsDownloadingCsv(true);
    try {
      if (passingsToExportLst.length > 0) {
        handleDownloadByTransactionClick('csv');
      } else {
        await handleDownloadClick('csv');
      }
    } finally {
      setIsDownloadingCsv(false);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: downloadButtons
  }, /*#__PURE__*/React.createElement("div", {
    className: column
  }, /*#__PURE__*/React.createElement(DownloadButton, {
    disabled: disableButtons,
    loading: isDownloadingCsv,
    onClick: handleDownloadCsvClick
  }, `${t('buttons.export_passings_list')} (CSV)`)), /*#__PURE__*/React.createElement("div", {
    className: column
  }, /*#__PURE__*/React.createElement(DownloadButton, {
    disabled: disableButtons,
    loading: isDownloadingPdf,
    onClick: handleDownloadPdfClick
  }, `${t('buttons.export_passings_list')} (PDF)`)));
}